module.exports = __webpack_public_path__ + "static/media/dummy-avatar.887fe0f6.jpg";